var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1HighQualityService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h-1.56a28.48 28.48 0 00-26.29-27.94 3 3 0 10-4.3 0A28.48 28.48 0 009.56 39H8a2 2 0 100 4h60a2 2 0 000-4zm-54.44 0a24.44 24.44 0 1148.88 0H13.56zm52.66 13.24a2 2 0 01-.45 2.76c-2.84 1.59-9 5.29-14.45 8.1-.6.32-1.61.9-4.61.9H31.27s-1.62 0-3.44.12C26.92 64.19 17.31 66.4 15 67V51.39a49.279 49.279 0 007.25-2.64A14 14 0 0129.46 47c3.42 0 12.63 3 12.63 3H49a2 2 0 011.92 2 2.05 2.05 0 01-.56 1.4A2 2 0 0149 54H31v3h20.68s9.75-4.29 11.88-5.32a2 2 0 012.66.56zM8 49h4v20H8V49z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_High_quality_service.f28259bb.svg";
export { SvgK1HighQualityService as ReactComponent };